import { FC } from 'react';

interface Props {
	variation?: 'white' | 'green';
	size?: string | number;
	className?: string;
}

const ArrowPrev: FC<Props> = ({ variation, size = 24, className }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={Number(size) + 1}
		height={size}
		viewBox="0 0 25 24"
		fill="none"
		className={className}
	>
		<path
			d="M15.9152 6.58023L14.8542 5.52024L9.0752 11.2972C8.98205 11.3898 8.90812 11.4999 8.85767 11.6211C8.80722 11.7424 8.78125 11.8724 8.78125 12.0037C8.78125 12.1351 8.80722 12.2651 8.85767 12.3863C8.90812 12.5076 8.98205 12.6177 9.0752 12.7102L14.8542 18.4902L15.9142 17.4302L10.4902 12.0052L15.9152 6.58023Z"
			fill={variation === 'white' ? '#fff' : variation === 'green' ? '#39F500' : 'currentColor'}
		/>
	</svg>
);

export default ArrowPrev;
